import {gql, useMutation} from "@apollo/client";
import ProjectCustomizeForm from "../../components/editor/ProjectCustomizeForm";
import {Project, LanguageCode, MutationUpdateChildrenArgs, MutationUpdateProjectArgs} from "../../schema";

export type queryVars = {
  projectId: Project["id"],
  language: LanguageCode
}

export type queryData = {
  project: Project,
  projects: Project[]
}

export const query = gql`
  query EditorEditProjectSceneQuery($projectId: ID!) {
    project: getProject(projectId: $projectId) {
      accessToken
      ...ProjectCustomizeForm
    }

    projects: getProjects {
      __typename
      id
      name
    }
  }
  ${ProjectCustomizeForm.fragments.root}
`;

export function useUpdateProjectMutation() {
  return useMutation<{project: Project}, MutationUpdateProjectArgs>(updateProjectMutation);
}

const updateProjectMutation = gql`
  mutation UpdateProjectMutation($id: ID!, $data: ProjectInput!) {
    project: updateProject(id: $id, data: $data) {
      name
      languageCode
      ...ProjectCustomizeForm
    }
  }

  ${ProjectCustomizeForm.fragments.root}
`;

export function useUpdateChildrenMutation() {
  return useMutation<{succsess: Boolean}, MutationUpdateChildrenArgs>(updateChildrenMutation);
}

const updateChildrenMutation = gql`
  mutation updateChildrenMutation($projectId: ID) {
    success: updateChildren(projectId: $projectId)
  }
`;